var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loading-view'):_vm._e(),_c('h1',{staticClass:"bd-title pageTitle",attrs:{"id":"content"}},[_vm._v(" Quote "),(_vm.quote_response)?_c('small',[_vm._v(_vm._s(_vm.quote_response.label))]):_vm._e()]),_c('div',[(_vm.quote_response)?_c('quote-read',{attrs:{"response":_vm.quote_response}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }